import React from "react";
import Style from "./Title.module.scss";
export const Title = () => {
  return <h1 className={Style.ContentHeader__title}>Projects</h1>;
};
